import { Button } from '@brighterion/br-ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import DeleteMerchantModal from 'Routes/Overrides/components/DeleteMerchantModal';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import styles from './DeleteMerchantBtn.css';

type Props = {
    merchantId: string;
    templateRepositoryId: number;
};

const DeleteMerchantBtn = ({ merchantId, templateRepositoryId }: Props) => {
    const { t } = useTranslation();
    const history = useHistory();
    const [deleteMerchantOpen, setDeleteMerchantOpen] = useState(false);

    const deleteMerchant = () => {
        setDeleteMerchantOpen(true);
    };

    return (
        <span className={styles.buttonWrapper}>
            <Button
                size='small'
                variant='secondary'
                data-testid='delete-merchant'
                onClick={handleOnClickEvent(deleteMerchant)}
                onKeyDown={handleKeyEvent(deleteMerchant)}
            >
                {t('Delete Merchant')}
            </Button>
            <DeleteMerchantModal
                isOpen={deleteMerchantOpen}
                onClose={() => setDeleteMerchantOpen(false)}
                onSuccess={() => history.push('/overrides')}
                merchantId={merchantId}
                templateRepositoryId={templateRepositoryId}
            />
        </span>
    );
};

export default DeleteMerchantBtn;
